import React, { useMemo, useState } from "react";
import { NftResponse } from "baaanggg";

export interface Props {
  nft: NftResponse;
  onTransfer: (recipientAddress?: string) => void;
}

function NftTransferItemBox({ nft, onTransfer }: Props) {
  const [receiverAddress, setReceiverAddress] = useState<string>("");

  const disabled = useMemo(
    () => receiverAddress.trim().length === 0,
    [receiverAddress]
  );

  return (
    <div
      className="tab-pane fade show active"
      id="transfer"
      role="tabpanel"
      aria-labelledby="transfer-tab"
    >
      <div className="mb-4 items-center justify-center sm:flex sm:flex-wrap">
        <div className="flex-1">
          <label className="mb-3 block font-display text-base font-semibold text-jacarta-700 dark:text-white">
            Transfer this NFT
          </label>
          <input
            onChange={(v) => setReceiverAddress(v.target.value)}
            type="text"
            className="h-12 w-full rounded-lg border border-jacarta-100 px-3 focus:ring-inset focus:ring-accent dark:border-jacarta-600 dark:bg-jacarta-700 dark:text-white dark:placeholder-jacarta-300"
            value={receiverAddress}
            placeholder="terra1..."
          />
          <p className="mt-2 text-2xs dark:text-jacarta-300">
            Enter recipient Terra address (e.g. <code>terra1...</code>).
          </p>
        </div>
      </div>

      <button
        disabled={disabled}
        onClick={() => onTransfer(receiverAddress.trim())}
        className="mb-4 inline-block w-full rounded-full bg-jacarta-500 px-8 py-3 text-center font-semibold text-white transition-all hover:bg-jacarta-600"
        title={
          disabled ? "Recipient address is required" : `Transfer "${nft.name}"`
        }
      >
        Transfer "{nft.name}"
      </button>
    </div>
  );
}

export default NftTransferItemBox;
